module.exports = "/images/starPostes.svg?627e35f212d1c1ff8fa10ca80f024442";